import React from 'react'
import { FundersDashboard } from './components/FundersDashboard'

const Funders2025App: React.FC = () => {
  return <FundersDashboard />
}

export default Funders2025App